import { CategoryGroupListPage } from "@/features/category-group/pages/CategoryGroupListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/")({
	component: CategoryGroupListPage,
});
